export const filters = {
    "digital-transformation": {
      "id": "digital-transformation",
      "label": "Digital Transformations",
      "icon": "database",
      "color": "blue",
      "subcategories": {
        "data-migration": {
          "id": "data-migration",
          "label": "Data Migrations",
          "icon": "database",
          "color": "blue",
          "options": [
            {
              "id": "extract",
              "label": "Extract",
              "icon": "file-text",
              "color": "blue",
              "types": [
                {
                  "id": "extract-pipeline",
                  "label": "Pipeline",
                  "icon": "layers",
                  "color": "blue"
                },
                {
                  "id": "extract-script",
                  "label": "Script",
                  "icon": "code",
                  "color": "blue",
                  "languages": [
                    {
                      "id": "extract-script-sql",
                      "label": "SQL",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "extract-script-mysql",
                      "label": "MYSQL",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "extract-script-postgresql",
                      "label": "POSTGRESQL",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "extract-script-oracle",
                      "label": "ORACLE",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "extract-script-python",
                      "label": "Python",
                      "icon": "code",
                      "color": "blue"
                    }
                  ]
                }
              ]
            },
            {
              "id": "transform",
              "label": "Transform",
              "icon": "settings",
              "color": "blue",
              "types": [
                {
                  "id": "transform-pipeline",
                  "label": "Pipeline",
                  "icon": "layers",
                  "color": "blue"
                },
                {
                  "id": "transform-script",
                  "label": "Script",
                  "icon": "code",
                  "color": "blue",
                  "languages": [
                    {
                      "id": "transform-script-sql",
                      "label": "SQL",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "transform-script-mysql",
                      "label": "MYSQL",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "transform-script-postgresql",
                      "label": "POSTGRESQL",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "transform-script-oracle",
                      "label": "ORACLE",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "transform-script-python",
                      "label": "Python",
                      "icon": "code",
                      "color": "blue"
                    }
                  ]
                }
              ]
            },
            {
              "id": "load",
              "label": "Load",
              "icon": "upload",
              "color": "blue",
              "types": [
                {
                  "id": "load-pipeline",
                  "label": "Pipeline",
                  "icon": "layers",
                  "color": "blue"
                },
                {
                  "id": "load-script",
                  "label": "Script",
                  "icon": "code",
                  "color": "blue",
                  "languages": [
                    {
                      "id": "load-script-sql",
                      "label": "SQL",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "load-script-mysql",
                      "label": "MYSQL",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "load-script-postgresql",
                      "label": "POSTGRESQL",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "load-script-oracle",
                      "label": "ORACLE",
                      "icon": "database",
                      "color": "orange"
                    },
                    {
                      "id": "load-script-python",
                      "label": "Python",
                      "icon": "code",
                      "color": "blue"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "automation-testing": {
          "id": "automation-testing",
          "label": "Automation Testing",
          "icon": "code",
          "color": "blue",
          "options": [
            {
              "id": "test-automation",
              "label": "Test Automation",
              "icon": "check-circle",
              "color": "green"
            }
          ]
        },
        "integrations": {
          "id": "integrations",
          "label": "Integrations",
          "icon": "git-merge",
          "color": "blue",
          "options": [
            {
              "id": "api-integration",
              "label": "API Integration",
              "icon": "link",
              "color": "blue"
            }
          ]
        }
      }
    },
    "business-automation": {
      "id": "business-automation",
      "label": "Business Process Automation",
      "icon": "settings",
      "color": "orange",
      "subcategories": {
        "workflow-automation": {
          "id": "workflow-automation",
          "label": "Workflow Automations",
          "icon": "workflow",
          "color": "orange",
          "options": [
            {
              "id": "workflow-design",
              "label": "Workflow Design",
              "icon": "flow",
              "color": "orange"
            }
          ]
        },
        "erp-ai-agents": {
          "id": "erp-ai-agents",
          "label": "ERP AI Agents",
          "icon": "bot",
          "color": "orange",
          "options": [
            {
              "id": "erp-automation",
              "label": "ERP Automation",
              "icon": "bot",
              "color": "orange"
            }
          ]
        },
        "d365-ai-agents": {
          "id": "d365-ai-agents",
          "label": "D365 AI Agents",
          "icon": "microsoft",
          "color": "orange",
          "options": [
            {
              "id": "d365-automation",
              "label": "D365 Automation",
              "icon": "microsoft",
              "color": "orange"
            }
          ]
        }
      }
    },
    "enterprise-data": {
      "id": "enterprise-data",
      "label": "Enterprise Data Management & Analytics",
      "icon": "database",
      "color": "purple",
      "subcategories": {
        "data-analytics": {
          "id": "data-analytics",
          "label": "Data Analytics",
          "icon": "chart",
          "color": "purple",
          "options": [
            {
              "id": "data-engineering",
              "label": "Data Engineering",
              "icon": "tool",
              "color": "purple"
            },
            {
              "id": "data-modeling",
              "label": "Data Modeling",
              "icon": "diagram",
              "color": "purple"
            },
            {
              "id": "business-analytics",
              "label": "Business Analytics Automations",
              "icon": "chart-bar",
              "color": "purple"
            }
          ]
        },
        "data-management": {
          "id": "data-management",
          "label": "Data Management",
          "icon": "shield",
          "color": "purple",
          "options": [
            {
              "id": "pii-identification",
              "label": "PII Identifications",
              "icon": "eye",
              "color": "purple"
            },
            {
              "id": "data-analysis",
              "label": "Data Analysis",
              "icon": "search",
              "color": "purple"
            },
            {
              "id": "data-quality",
              "label": "Data Quality",
              "icon": "check",
              "color": "purple"
            }
          ]
        }
      }
    }
  };